import React from 'react';
import { IEscrowExpectedIncomingWireData } from 'types/accounting/data/IEscrowExpectedIncomingWireData';
import { IPageData } from 'types/rest/IPageData';
import { CardTW } from 'tailwindComponents/CardTW/CardTW';
import { IPotentialMatch } from './IPotentialMatch';
import { ExpectedDisplay } from './ExpectedDisplay';

export interface IExpectedWireTableDisplayProps {
  data: IPageData<IEscrowExpectedIncomingWireData>;
  setPotentialMatch: (x: IPotentialMatch) => void;
  accountNumber: string;
}

export const ExpectedWireTableDisplay: React.FC<IExpectedWireTableDisplayProps> = ({
  data,
  setPotentialMatch,
  accountNumber,
}) => {
  return (
    <CardTW
      title={
        <>
          Orders Expecting Wires
          {data && (
            <span className="ml-8 rounded-full bg-green-100 px-2 py-1 align-middle text-xs font-medium text-green-700">
              {data.content.length} Item{data.content.length === 1 ? '' : 's'}
            </span>
          )}
        </>
      }
      isCollapsible
      isCollapsed
      contentClassName={'px-0'}
    >
      <div>
        {data.content.map((expectedWire) => (
          <ExpectedDisplay
            key={expectedWire.id}
            expected={expectedWire}
            accountNumber={accountNumber}
            actionLabel={'Match'}
            onAction={() => setPotentialMatch({ expectedWire })}
          />
        ))}
      </div>
    </CardTW>
  );
};
